<template>
  <div id="app-root">
    <router-view :key="topRouteKey" />
    <LoginModal />
    <ProfileModal />
    <UserInfoModals />
    <MemberMessagePopup />
  </div>
</template>

<script>
import LoginModal from '@/components/auth/LoginModal.vue'
import ProfileModal from '@/components/user/ProfileModal.vue'
import UserInfoModals from '@/components/user/UserInfoModals.vue'
import MemberMessagePopup from '@/components/user/MemberMessagePopup.vue'

export default {
  name: 'App',
  components: { LoginModal, ProfileModal, UserInfoModals, MemberMessagePopup },
  computed: {
    topRouteKey() {
      return this.$route.matched[0]?.path || this.$route.path
    }
  }
}
</script>
